import { render, staticRenderFns } from "./AuditNoteWithContent.vue?vue&type=template&id=33bdb1a5&scoped=true&"
import script from "./AuditNoteWithContent.vue?vue&type=script&lang=js&"
export * from "./AuditNoteWithContent.vue?vue&type=script&lang=js&"
import style0 from "./AuditNoteWithContent.vue?vue&type=style&index=0&id=33bdb1a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bdb1a5",
  null
  
)

export default component.exports